import { Component, ContentChild, EventEmitter, HostBinding, Inject, Input, Output, ViewChild } from '@angular/core';
import { DropdownContentComponent } from './dropdown-Content/dropdown-content.component';
import { DropdownTriggerDirective } from './dropdown-trigger/dropdown-trigger.directive';
import { DropdownHostDirective } from './dropdown-host/dropdown-host.directive';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
export type Align = 'start' | 'center' | 'end';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  @HostBinding('class.opened') @Input() opened: boolean = false;
  @ContentChild(DropdownTriggerDirective, { static: true }) dropdownButton!: DropdownTriggerDirective;
  @ViewChild(DropdownHostDirective, { static: true }) dropdownHost!: DropdownHostDirective;
  @Input() width: number | 'auto' = 'auto';
  @Input() panelClass!: string;
  @Input() align: Align = 'start';
  @Input() close: EventEmitter<void> = new EventEmitter<void>();
  @Input() appendToBody: boolean = true;
  @Input() disabled: boolean = false;
  @Output() showDropdown: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeDropdown: EventEmitter<void> = new EventEmitter<void>();
  delay: number = 0
  constructor() {}

  ngOnInit() {
    if (!this.disabled && this.dropdownButton) {
      this.dropdownButton.toggle.subscribe((state: boolean) => {
        this.toggleDropdown(state);
      });
    }
  }

  toggleDropdown(state: boolean) {
    if (this.opened) {
      this.removeDynamicComponent();
    } else {
      this.createDynamicComponent();
    }

    this.opened = state;
  }

  createDynamicComponent() {
    const contentView = this.dropdownHost.templateRef.createEmbeddedView(null);
    contentView.detectChanges();

    const viewContainerRef = this.dropdownHost.viewContainerRef;

    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<DropdownContentComponent>(
      DropdownContentComponent,
      { projectableNodes: [contentView.rootNodes] }
    );

    this.setComponentProperties(componentRef.instance);
  }

  removeDynamicComponent() {
    const viewContainerRef = this.dropdownHost.viewContainerRef;

    setTimeout(() => {
      viewContainerRef.clear();
    }, 300);
  }

  setComponentProperties(component: DropdownContentComponent) {
    const triggerParams: DOMRect = this.dropdownButton.getTriggerParams();

    component.width = this.width === 'auto' ? triggerParams.width : this.width;
    component.triggerWidth = triggerParams.width;
    component.panelClass = this.panelClass;
    component.align = this.align;
    component.closeInput = this.close;

    component.showDropdown.subscribe(() => {
      this.showDropdown.emit();
    });	
    component.closeDropdown.subscribe(() => {
      this.closeDropdown.emit();
    });
    
    component.setParameters(triggerParams);
    if (this.appendToBody) {
      this.delay = 100;

      component.appendComponentToBody();
    }

    setTimeout(() => {
      component.show();
    }, this.delay);

    component.closeDropdown.subscribe(() => {
      this.toggleDropdown(false);
      this.dropdownButton.active = false;
    });
  }
}
